var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRibbonVisible)?_c('div',{staticClass:"wc-promo-ribbon py-1 px-2 font-size-xs rounded",class:_vm.variant},[_vm._v(" "+_vm._s(_vm.textContent)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }